import angular from 'angular';

angular.module('commonServices').filter('deviation', [
  '$translate',
  function($translate) {
    return function(input) {
      if (typeof input === 'undefined' || input === null) return '';
      let nr;
      if (typeof input === 'string') nr = parseInt(input, 10);
      if (typeof input === 'number') nr = Math.round(input);
      const sign = input < 0 ? '-' : '+';
      nr = Math.abs(nr); //Make absolute
      const unit = $translate.instant('days'); //If we support other units in the future, this will probably depend on an extra parameter
      return `${sign} ${nr} ${unit}`;
    };
  },
]);
